











































































































































































































import { Component, Vue, Ref, Watch, Prop } from 'vue-property-decorator'
import { ElTree } from 'element-ui/types/tree'
import ParamsFilterConditionPicker from '@/components/common/ParamsFilterConditionPicker.vue'
import moment from 'moment'
import { debounce } from 'lodash'

@Component({
  components: { ParamsFilterConditionPicker }
})
export default class ParamsFilter extends Vue {
  @Ref('searchConditionsTree') readonly searchConditionsTree!: ElTree<any, any>
  @Ref('conditionPicker') readonly conditionPicker!: ParamsFilterConditionPicker
  @Prop() json!: any

  private searchConditions: any[] = this.json.children || []
  public selectedConditions: any[] = []
  private allConditionFilterText: string = ''
  private selectedConditionFilterText: string = ''
  // search config
  private searchConfigs: any[] = []
  private searchConfigDialogVisible: boolean = false
  // 防抖的filter，只在第一次搜索时赋值
  private debounceAllConditionFilter: any = null

  // 选中的搜索条件 map, key 为 query_name
  get selectedConditionsMap () {
    return this.selectedConditions.reduce((prev: any, current: any) => {
      prev[current.querry_name] = true
      return prev
    }, {})
  }

  /**
   * 获取当前选中的搜索条件参数
   */
  public getSearchCriteria () {
    return this.selectedConditions.reduce((prev: any, current: any) => {
      let type = current.type
      let query = current.structure_tree
      if (type === 'category') {
        prev[query] = current.selectedCategory
      } else if (type === 'binary') {
        prev[query] = current.selectedBinary
      } else if (type === 'range') {
        prev[query] = [current.default_min, current.default_max]
      }
      return prev
    }, {})
  }

  /**
   * category 类型的搜索条件选择类型
   * @param candidates 待选择的类型列表
   * @param selectedCandidates 已选择的类型列表
   * @param searchConditionLabel 当前的搜索条件名称
   */
  private searchCategorySelect (candidates: string[], selectedCandidates: string[], searchConditionLabel: string) {
    this.conditionPicker.show = true
    this.conditionPicker.conditionName = searchConditionLabel
    this.conditionPicker.setData(candidates, selectedCandidates)
    return new Promise((resolve, reject) => {
      this.conditionPicker.$once('confirm', resolve) // 点击确认按钮的时候先触发 confirm 事件, 再触发 close 事件, confirm 的时候 promise 已经 fulfilled 了, 所以不会受到后面的 close 事件的影响
      this.conditionPicker.$once('close', reject)
    })
  }

  /**
   * 添加搜索条件
   * @param data 选中的搜索条目信息
   * @private
   */
  private async addCondition (data: any) {
    if (data.type === 'category') {
      try {
        const selectedCategory = await this.searchCategorySelect(data.candidates, [], data.name)
        this.selectedConditions.push({
          ...data,
          visible: true,
          selectedCategory
        })
      } catch (e) {
        console.warn('cancel category select')
      }
    } else if (data.type === 'binary') {
      this.selectedConditions.push({
        ...data,
        visible: true,
        selectedBinary: true
      })
    } else if (data.type === 'range') {
      this.selectedConditions.push({
        ...data,
        visible: true
      })
    }
  }

  /**
   * 编辑搜索条件 category
   * @param data 搜索条目信息
   */
  private async editCategory (data: any) {
    try {
      data.selectedCategory = await this.searchCategorySelect(data.candidates, data.selectedCategory, data.name)
    } catch (e) {
      console.warn('cancel category select')
    }
  }

  /**
   * 删除搜索条件
   * @param index 要删除的搜索条件索引
   * @private
   */
  private removeCondition (index: number) {
    this.selectedConditions.splice(index, 1)
  }

  /**
   * 筛选所有的搜索条件
   * @param value 输入的关键字
   * @param data 搜索条目信息
   * @param node 节点
   * @private
   */
  private filterAllConditions (value: string, data: any, node: any) {
    if (!value) return true
    return this.findSearchKey(node, value)
  }
  /**
   * 递归往上查找 node.label 是否包含 key
   * @param node 节点
   * @param key 要查找的 key
   */
  private findSearchKey (node:any, key: string): boolean {
    if (!node.label) {
      return false
    }
    if (node.label.indexOf(key) !== -1) {
      return true
    }
    if (!node.parent) {
      return false
    }
    return this.findSearchKey(node.parent, key)
  }

  /**
   * 筛选选中的搜索条件
   * @private
   */
  private filterSelectedConditions () {
    this.selectedConditions.forEach((item: any) => {
      item.visible = item.name.indexOf(this.selectedConditionFilterText) !== -1
    })
  }

  /**
   * 保存搜索条件
   * @private
   */
  private async saveSearchConfig () {
    try {
      // @ts-ignore
      const name = (await this.$prompt('Please input your search configure name:')).value
      if (name === null) {
        alert('configure name should not be null!')
        return
      }
      const curTimeStr = moment().format()
      let s = []
      if (localStorage.getItem('searchConfig')) {
        // @ts-ignore
        s = JSON.parse(localStorage.getItem('searchConfig'))
      }
      s.push({
        configName: name,
        configTime: curTimeStr,
        searchConfig: this.selectedConditions
      })
      localStorage.setItem('searchConfig', JSON.stringify(s))
      this.$message({
        message: 'Saved successfully!',
        type: 'success'
      })
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * 加载已保存的搜索条件对话框
   * @private
   */
  private loadSearchConfig () {
    if (localStorage.getItem('searchConfig')) {
      // @ts-ignore
      this.searchConfigs = JSON.parse(localStorage.getItem('searchConfig'))
    } else {
      this.searchConfigs = []
    }
    this.searchConfigDialogVisible = true
  }

  /**
   * 选择某一搜索条件
   * @param index 要选择条件的索引
   * @private
   */
  private handleSelect (index: any) {
    this.selectedConditions = this.searchConfigs[index]['searchConfig']
    this.searchConfigDialogVisible = false
  }

  /**
   * 删除某一搜索条件
   * @param index 要删除条件的索引
   * @private
   */
  private handleDelete (index: any) {
    this.searchConfigs.splice(index, 1)
    localStorage.setItem('searchConfig', JSON.stringify(this.searchConfigs))
  }

  @Watch('allConditionFilterText')
  allConditionFilterChanged (newVal: string) {
    if (!this.debounceAllConditionFilter) {
      this.debounceAllConditionFilter = debounce(this.searchConditionsTree.filter, 500)
    }
    this.debounceAllConditionFilter(newVal)
  }

  @Watch('selectedConditionFilterText')
  selectedConditionFilterChanged () {
    this.filterSelectedConditions()
  }

  @Watch('json')
  jsonFileChanged () {
    this.searchConditions = this.json.children
  }
}
